// src/utils/checkSummary.js
//
// Espejo NO financiero de un cheque (colección `checkSummaries`, firestore.rules).
// Un CSR Assistant lee esto en vez de `checks`: Firestore no puede entregar un
// documento parcial, así que lo que gana CSR (porcentajes, comisiones, pagos,
// invoice, deuda) simplemente no se copia aquí. Lista blanca: un campo nuevo
// del cheque NO llega al espejo hasta que se agregue a propósito.
//
// `checks` sigue siendo la fuente de verdad; el espejo lo mantienen
// claimService.js (altas y ediciones) y flowService.js (cambios de paso).

export const CHECK_SUMMARY_KEYS = [
  'claimRecordId', 'companyName', 'insuranceCompanyName',
  'clientName', 'clientEmail', 'clientPhone', 'clientAddress',
  'policyNumber', 'incidentDate', 'cause', 'claimNumber', 'crmClaimId',
  'adjusterName', 'accessNames',
  'checkNumber', 'checkDate', 'paymentType', 'payableTo', 'hasMortgage',
  'amount', 'flow', 'realValuesConfirmed', 'crmUploadConfirmed', 'checkAttachment',
  'createdAt', 'createdBy', 'status'
];

// Solo copia las claves de la lista blanca que el objeto trae: sirve igual
// para un cheque entero (alta) que para un parche de edición.
export const buildCheckSummary = (check = {}) => Object.fromEntries(
  CHECK_SUMMARY_KEYS.filter(key => key in check && check[key] !== undefined).map(key => [key, check[key]])
);
